import React from 'react';
import { 
  getUsersPaged,
  deleteUser,
} from '@bforms-web/common';

import UserList, { UserListProps } from '../../components/User/List';

const dispatchers: Pick<UserListProps, 'getUsersPaged' | 'onDelete'> = {
  getUsersPaged,
  onDelete: deleteUser.execute.bind(deleteUser),
};

export default function UserListComposer(): JSX.Element {
  return <UserList {...dispatchers} />;
}
